import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';

import { BASE_URL } from '../constants';

const baseQuery = fetchBaseQuery({
  baseUrl:     '/',
  credentials: 'include',   // send cookies
  prepareHeaders: (headers) => {
    // Read the non-httpOnly csrf-token cookie and echo it as a header
    const csrfToken = document.cookie
      .split('; ')
      .find(row => row.startsWith('csrf-token='))
      ?.split('=')[1];

    if (csrfToken) {
      headers.set('X-CSRF-Token', csrfToken);
    }
    return headers;
  },
});

export const apiSlice = createApi({
  baseQuery,
  tagTypes: [
    'Product', 
    'Activity', 
    'ClinicalSite', 
    'Order', 
    'User', 
    'ClinicalSites', 
    'Activities',
    'Shift',        // Add this
    'ShiftRequest', // Add this if needed
    'Agency', 'HospitalLocation', 'Availability', 'Csp', 'Cpi', 'StaffDir', 'PayRecord', 'RunHistory', 'EmailLog'       // Add this if needed
  ],
  endpoints: () => ({}),
});

//import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
//import { BASE_URL } from '../constants';
//const baseQuery = fetchBaseQuery({ baseUrl: BASE_URL });
//export const apiSlice = createApi({
//  baseQuery,
//  tagTypes: ['Product', 'Activity', 'ClinicalSite', 'Order', 'User', 'ClinicalSites', 'Activities'],
//  endpoints: (builder) => ({}),
//});

// In your existing apiSlice.js, add to the tagTypes:
//tagTypes: ['User', 'Shift', 'HospitalLocation', 'Availability'],

// And in the endpoints, add:
// (You'll add this to the injectEndpoints if you're using RTK Query)
